import {
    ADDITIONAL_PAGE_OPTIONS,
    SalesChannel,
    SALESCHANNEL_FAMILY_FRIENDS,
    SALESCHANNEL_REDPLUS,
} from '@vfde-sails/constants';

const getPageUrlForCustomerConfig = (salesChannel: SalesChannel, hasGigakombi: boolean): string => {
    const redirectionPages = hasGigakombi
        ? window[ADDITIONAL_PAGE_OPTIONS].redirectionPages.gigakombi
        : window[ADDITIONAL_PAGE_OPTIONS].redirectionPages.default;

    const pageUrl =
        redirectionPages[salesChannel as Exclude<SalesChannel, typeof SALESCHANNEL_FAMILY_FRIENDS | typeof SALESCHANNEL_REDPLUS>];

    if (!pageUrl) {
        throw new Error(`The current selection has no redirection page and is therefore not valid. Sales channel: ${salesChannel}, Gigakombi: ${hasGigakombi}`);
    }

    return pageUrl;
};

export default getPageUrlForCustomerConfig;
